'use strict';

var cssVars = require('css-vars-ponyfill/dist/css-vars-ponyfill.min');

module.exports = {
    initCssVarsPolyfill: function () {
        cssVars();
    }
};
